import styled from 'styled-components';

export const StyledArOpen = styled.div`
    width: 0%;
    height: 0%;
`;